import type {CSSProperties} from "aphrodite";

// TODO: can we use WB typography?
export const bodyXsmallBold: CSSProperties = {
    // For emphasized metadata, descriptions, etc
    fontFamily: "inherit",
    fontSize: 15,
    fontWeight: "bold",
    lineHeight: "22px",
};
